export default "__VITE_ASSET__pv$Ui2ch__"